module.exports = __webpack_public_path__ + "img/img_photo1@2x.53c11b0e.png";